import moment from "moment";

export const time = (date) => moment(date).format('DD-MM-YYYY | HH:mm')
export const hour = (date) => moment(date).format('HH:mm:ss')
export const statTime = (date) => moment(date).format('HH:mm - DD-MM-YYYY')